/* eslint-disable */
const config = CONFIG;

config.dev = $('body').is('.development');

export default config;
